import customerReducer from './customerReducer';

export * from './customerActions';

export default customerReducer;